import {
  AppBar,
  Badge,
  Box,
  Hidden,
  IconButton,
  Toolbar,
} from '@material-ui/core';
import {
  Input as InputIcon,
  Menu as MenuIcon,
  NotificationsOutlined as NotificationsIcon,
} from '@material-ui/icons';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import useToken from 'src/hooks/useToken';
import { userSignOut } from 'src/redux/actions';
import API from 'src/util/api';

import ModalComponent from './common/modalComponent';
import Logo from './Logo';


const DashboardNavbar = ({ onMobileNavOpen }) => {
  const [notifications] = useState([]);
  const [isOpenModal, setIsOpenModal] = useState(false);

  const { setToken } = useToken();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogout = async () => {
    try {
      await API.get('logout');
      dispatch(userSignOut());
      setToken(null);
    } catch (err) {
      console.error('Logout failed:', err);
    } finally {
      navigate('/login');
    }
  };

  const handleLogoClick = () => {
    API.post('/refreshToken').catch((err) =>
      console.error('Token refresh failed:', err)
    );
  };

  return (
    <>
      <AppBar elevation={0}>
        <Toolbar>
          <Logo onClick={handleLogoClick} style={{ cursor: 'pointer' }} />
          <Box sx={{ flexGrow: 1 }} />
          <Hidden mdDown>
            <IconButton color="inherit" size="large">
              <Badge
                badgeContent={notifications.length}
                color="primary"
                variant="dot"
              >
                <NotificationsIcon />
              </Badge>
            </IconButton>
            <IconButton
              color="inherit"
              size="large"
              onClick={() => setIsOpenModal(true)}
            >
              <InputIcon />
            </IconButton>
          </Hidden>
          <Hidden lgUp>
            <IconButton
              color="inherit"
              size="large"
              onClick={onMobileNavOpen}
            >
              <MenuIcon />
            </IconButton>
          </Hidden>
        </Toolbar>
      </AppBar>

      {/* Logout Confirmation Dialog */}
      {isOpenModal && <ModalComponent
        open={isOpenModal}
        onClose={() => setIsOpenModal(false)}
        onConfirm={() => {
          setIsOpenModal(false);
          handleLogout();
        }}
        title="Are you sure you want to log out?"
        confirmBtn="YES, LOGOUT"
      />}
    </>
  );
};

DashboardNavbar.propTypes = {
  onMobileNavOpen: PropTypes.func,
};

export default DashboardNavbar;
